import React, {useMemo} from 'react';
import {ISelectCustomItem} from "@ui/select/selectCustom/types";
import {useTranslation} from 'react-i18next';
import SelectMultiSearch from "@ui/select/selectMultiSearch/SelectMultiSearch";
import {TaskWayPointSingleVoyage} from "@containers/singleVoyage/tasks/table/types";
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';

interface IProps {
	value: string[],
	onChange: (value: string[],) => void,
	label?: string,
	waypoints: TaskWayPointSingleVoyage[]
	error?: boolean,
	errorMessage?: string,
	width?: string
	/** All / none toggle. Pointless for templates limited to a single stop. */
	hasSelectAll?: boolean
}

const SelectMultipleTasksWaypointsByDataSingleVoyage = ({
															value,
															onChange,
															label,
															waypoints,
															error,
															errorMessage,
															width,
															hasSelectAll,
														}: IProps) => {

	const {t} = useTranslation()


	const dataSelect: ISelectCustomItem<TaskWayPointSingleVoyage>[] = useMemo(() => {
		if (!waypoints?.length) {
			return []
		}
		return waypoints.filter((point) => point.type === 'POINT_RADIUS' || point?.type === 'RFID_POINT').map((point) => {
			return {
				label: point.name,
				value: point.id?.toString(),
			}
		})
	}, [waypoints])

	const allSelected = dataSelect.length >= 1 && value?.length === dataSelect.length

	const onToggleAll = () => {
		onChange(allSelected ? [] : dataSelect.map((item) => item.value?.toString()))
	}

	const select = (
		<SelectMultiSearch
			value={value}
			onChange={onChange}
			data={dataSelect}
			label={label ?? t('base.points')}
			error={error}
			width={width}
			errorMessage={errorMessage}
		/>
	)

	if (!hasSelectAll || dataSelect.length < 2) {
		return select
	}

	return (
		<Stack
			gap={'4px'}
			sx={{width: '100%'}}
		>
			<Stack
				direction={'row'}
				justifyContent={'flex-end'}
			>
				<Link
					component={'button'}
					type={'button'}
					underline={'hover'}
					onClick={onToggleAll}
					sx={{fontSize: '12px'}}
				>
					{allSelected
						? t('singleVoyage.clearAllWaypoints')
						: t('singleVoyage.selectAllWaypoints', {count: dataSelect.length})}
				</Link>
			</Stack>

			{select}
		</Stack>
	);
};

export default SelectMultipleTasksWaypointsByDataSingleVoyage;
